import { Fieldset } from "@trussworks/react-uswds";
import { Dispatch, SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { AnalyticsAction, logEvent } from "../../../utils/analytics";
import {
  optionWithId,
  getLookupOptions
} from "../../../types/lookup";
import { 
  SearchFilters
 } from "../../../types/v1_schemas";
import FilterCheckbox from "./FilterCheckbox";
import { toggleItemInFilterList } from "../../../utils/filters/shared";

type PopulationsServedInputProps = {
  legend: string;
  compact?: boolean;
  filters: SearchFilters;
  setFilters: Dispatch<SetStateAction<SearchFilters>>;
};

function PopulationServedInput({
  legend,
  compact = false,
  filters,
  setFilters,
}: PopulationsServedInputProps) {
  // eslint-disable-next-line unused-imports/no-unused-vars
  const { t } = useTranslation();

  // eslint-disable-next-line unused-imports/no-unused-vars
  const [populationsServedOptions, setPopulationsServedOptions] = useState(() => getLookupOptions("community"));

  const setPopulationServedFilter = (populationServedOption: optionWithId) => {
    logEvent(AnalyticsAction.UpdateFilter, {
      label: "populations served",
      filter_type: "populations served",
      filter_value: populationServedOption.lineageText,
    });
    setFilters({
      ...filters,
      patientCommunityIds: toggleItemInFilterList(
        filters.patientCommunityIds ?? [],
        populationServedOption.id.toString()
      ) as [],
    });
  };

  return (
    <Fieldset legend={legend} legendStyle={compact ? "srOnly" : "large"}>
      {populationsServedOptions.map((option) => (
        <FilterCheckbox
          name={option.id.toString()}
          value={option.id.toString()}
          label={t(`${option.translate}`)}
          selectedFilterValues={filters.patientCommunityIds ?? []}
          onChange={() => {setPopulationServedFilter(option);}}
          key={option.id.toString()}
        />
      ))}
    </Fieldset>
  );
}

export default PopulationServedInput;
